import { type QueryClient, useQueryClient } from "@tanstack/react-query";

import { USER_INFO_QUERY_KEY } from "Auth/Api/Queries/useUserInfoQuery";
import { JWT_KEY } from "Auth/Models/AuthConstants";
import { useAppNavigate } from "Infrastructure/Routing/useAppNavigate";
import { AppRouting } from "Infrastructure/Utils/UrlUtils";

export function useSignOut() {
  const queryClient = useQueryClient();
  const navigate = useAppNavigate();

  return () => {
    processSignOut(queryClient);
    navigate(AppRouting.SignIn.path());
  };
}

export function processSignOut(queryClient: QueryClient) {
  localStorage.removeItem(JWT_KEY);
  queryClient.setQueryData([USER_INFO_QUERY_KEY], null);
}
